export default "__VITE_ASSET__DnEn_vnb__"